import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import NewsArticles from '../components/NewsArticles';

const NewsPage: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center" color="secondary.main">
          Market News & Analysis
        </Typography>
        <Typography variant="body1" paragraph align="center" sx={{ mb: 4 }}>
          Expert insights and the latest developments in Gold and USD markets
        </Typography>
        
        {/* The NewsArticles component will load all articles from WordPress */}
        <NewsArticles showFullView={true} articlesPerPage={8} />
      </Box>
    </Container>
  );
};

export default NewsPage;